import React from 'react';

import styles from './InstructionTitle.scss';

const formatQuestionText = totalQuestion => {
  if (typeof totalQuestion === 'object' && totalQuestion !== null) {
    const { problems = 0, mcqs = 0 } = totalQuestion;
    if (problems > 0 && mcqs > 0) {
      return `${problems} Problems and ${mcqs} MCQs`;
    } else if (problems > 0) {
      return `${problems} Problems`;
    } else if (mcqs > 0) {
      return `${mcqs} MCQs`;
    } else {
      return '0 Questions';
    }
  } else if (typeof totalQuestion === 'number') {
    return `${totalQuestion} Questions`;
  }
  return `${totalQuestion} Questions`; // fallback
};

const InstructionTitle = ({ totalQuestion, timer, title }) => {
  return (
    <div className={styles['title-container']}>
      <h2 className={styles['title-heading']}>{title}</h2>
      <p className={styles['title-subtitle']}>
        {formatQuestionText(totalQuestion)} {timer > 0 ? `${timer} Minutes` : ''}
      </p>
    </div>
  );
};

export default InstructionTitle;
